import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'layout-fab-sub-tools',
    templateUrl: './layout-fab-sub-tools.component.html',
    styleUrls: ['./layout-fab-sub-tools.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatTooltip, MatIcon, NgIf, MatButtonModule],
})
export class LayoutFabSubToolsComponent {
    // data members

    @Input()
    isOpen = false;

    @Input()
    actionIcon?: string;

    @Input()
    estensaIcon?: string;

    @Input()
    tooltip: any;

    @Input()
    enableEstensaFontSet: boolean = true;

    @Input()
    smallFontEnabled: boolean = false;
    @Output()
    actionClick: EventEmitter<any> = new EventEmitter<any>();

    private _isMouseOver = false;

    get isMouseOver() {
        return this._isMouseOver;
    }

    // public functions

    onActionClick(event: any) {
        this.actionClick.emit(event);
    }

    onActionMouseEnter(_: MouseEvent) {
        this.isOpen = true;
    }

    onActionMouseLeave(_: MouseEvent) {
        if (!this.isMouseOver) {
            this.isOpen = false;
        }
    }

    onMouseEnter(_: MouseEvent) {
        this._isMouseOver = true;
        this.isOpen = true;
    }

    onMouseLeave(_: MouseEvent) {
        this._isMouseOver = false;
        this.isOpen = false;
    }
}
